import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M20 5H9l-7 7 7 7h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2Z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Line, { x1: "18", x2: "12", y1: "9", y2: "15", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "12", x2: "18", y1: "9", y2: "15", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Delete";
const Delete = memo(themed(Icon));
export {
  Delete
};
//# sourceMappingURL=delete.js.map
